<div style="padding: 10px ;">
<h1>Selectează unu sau mai multi semnatari</h1>
<div class="add-field">
    <div *ngFor="let row of functiiOperator" class="checkbox">
        <mat-checkbox color="primary" [(ngModel)]="row.checked">
            {{row.name}}
        </mat-checkbox>
    </div>
  
</div>
<div class="row mt-2">
    <div class="col d-flex justify-content-between">
      <button
        class="buttons"
        type="button"
        mat-flat-button
        (click)="closeDialog()"
      >
        {{ helper.dialogConfig.buttonLabels.close }}
      </button>
      <button
        class="buttons"
        type="submit"
        mat-flat-button
        color="primary"
        (click)="submitSemnatari()"
      >
        {{ helper.dialogConfig.buttonLabels.save }}
      </button>
    </div>
  </div>
</div>